<template>
  <div class="backTop">
    <el-button
      type="primary"
      icon="el-icon-arrow-up"
      @click="backTop"
    ></el-button>
  </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        backTop() {
            window.pageYOffset = 0
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
        }
    }
}
</script>

<style lang="scss">
@import '../../../node_modules/bulma/sass/utilities/mixins';

.backTop {
  margin-left: 180px;
  position: fixed;
  bottom: 50px;
  right: 0;
  z-index: 9999;

  @include mobile() {
    margin-left: 0;
  }

  .social a {
    border-bottom: none !important;
  }

  .fa.fa-heart {
    color: red;
  }
  button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    i {
      font-size: 20px;
      color: #ffffff;
    }
    padding-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// BackTop.vue?28f8ad5d